// Normalize text by removing accents (same as backend)
export const normalizeText = (text: string): string => {
  return text
    .toString()
    .normalize('NFD') // Convert accented characters to base + diacritic
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .toLowerCase()
    .trim();
};

export const slugify = (text: string): string => {
  return normalizeText(text)
    .replace(/\s+/g, '-')        // Replace spaces with -
    .replace(/[^\w\-]+/g, '')    // Remove all non-word chars
    .replace(/\-\-+/g, '-')      // Replace multiple - with single -
    .replace(/^-+/, '')          // Trim - from start of text
    .replace(/-+$/, '');         // Trim - from end of text
}; 